import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/coh")({
  component: React.lazy(() =>
    import("@/pages/landing-page/cohLanding").then((mod) => ({
      default: mod.default,
    })),
  ),
});
